import { render, staticRenderFns } from "./ExcludeWordsHint.vue?vue&type=template&id=33262158&scoped=true"
import script from "./ExcludeWordsHint.vue?vue&type=script&lang=js"
export * from "./ExcludeWordsHint.vue?vue&type=script&lang=js"
import style0 from "./ExcludeWordsHint.vue?vue&type=style&index=0&id=33262158&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33262158",
  null
  
)

export default component.exports